import type { HeadcountRequestsQuery } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { type ChildHeadcountRow } from 'modules/planning/types/headcount'
import { defaultChildRow, PARENT_NEW_HEADCOUNT } from 'modules/planning/consts/headcount'
import { extractSalaryRange } from 'modules/planning/lib/extractSalaryRange'
type RequestEdge = HeadcountRequestsQuery['planning']['requestsConnection']['edges'][number]
type HeadcountDetail = NonNullable<RequestEdge['node']['headcountDetail']>

const buildJobCatalogLabel = (detail: HeadcountDetail): string => {
  if (detail.jobCatalogTreeLevel) {
    const role = detail.jobCatalogTreeLevel.ancestor?.name ?? ''
    const level = detail.jobCatalogTreeLevel.name ?? ''
    return role ? `${role} > ${level}` : level
  }

  if (detail.oldJobCatalogLevel) {
    const role = detail.oldJobCatalogLevel.role?.name ?? ''
    const level = detail.oldJobCatalogLevel.name ?? ''
    return role ? `${role} > ${level}` : level
  }

  return ''
}

export const mapRequestToHeadcountRow = (edge: RequestEdge, _index: number): ChildHeadcountRow => {
  const node = edge.node
  const detail = node.headcountDetail
  const displayEmployee = node.employee
  return {
    ...defaultChildRow,
    id: node.id,
    parentType: PARENT_NEW_HEADCOUNT,
    rowKind: 'headcount_request',
    type: detail?.headcountRequestType ?? 'new',
    status: node.status ?? null,
    employeeId: displayEmployee?.id ?? '',
    employeeName: displayEmployee ? `${displayEmployee.firstName} ${displayEmployee.lastName}` : '',
    avatarUrl: buildUrl(displayEmployee?.avatar?.url),
    requestCode: detail?.draftName ?? '',
    managerName: detail?.manager ? `${detail.manager.firstName} ${detail.manager.lastName}` : '',
    managerAvatarUrl: buildUrl(detail?.manager?.avatar?.url),
    salary: detail?.salary != null ? String(detail.salary / 100) : '',
    periodCost: detail?.periodCost ?? '',
    currency: detail?.currency ?? '',
    workingTime: detail?.workingTime ?? '',
    workplace: detail?.location?.name ?? '',
    startDate: detail?.startDate ?? '',
    endDate: detail?.endDate ?? '',
    jobCatalogLabel: detail ? buildJobCatalogLabel(detail) : '',
    jobCatalogTreeNodeUuid: detail?.jobCatalogTreeLevel?.uuid ?? '',
    oldJobCatalogLevelId: detail?.oldJobCatalogLevel?.id ?? '',
    locationId: detail?.location?.id ?? '',
    managerId: detail?.manager?.id ?? '',
    salaryRange: extractSalaryRange(detail?.jobCatalogTreeLevel),
    contractType: detail?.contractType ?? null,
    salaryFrequency: detail?.salaryFrequency ?? null,
  }
}
